module.exports = __webpack_public_path__ + "img/744.0daa7db4.jpg";